import './ReelsAuth.sass';

import { FC, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { Button, Placeholder } from '$uikit';
import { useTranslator } from '$hooks';
import { profileActions } from '$store/profile';
import { AuthPopoverState } from '$store/models';

export const ReelsAuth: FC = () => {
  const t = useTranslator();
  const dispatch = useDispatch();

  const handleAuth = useCallback(() => {
    dispatch(profileActions.setAuthPopoverState(AuthPopoverState.REGISTER));
  }, []);

  return (
    <div className="ReelsAuth Reel__wrap">
      <div className="ReelsAuth__cont">
        <Placeholder
          title={t('reels_auth_title')}
          actions={<Button onClick={handleAuth}>{t('sign_in_button')}</Button>}
          centered
        >
          {t('reels_auth_caption')}
        </Placeholder>
      </div>
    </div>
  );
};
